/* SNR star sky: fine silver star points + faint constellation hairlines on any <canvas data-snr-sky>.
   Pauses offscreen; static frame for prefers-reduced-motion. */
(function () {
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(c) {
    if (c._snr) return; c._snr = 1;
    var x = c.getContext('2d'), W, H, D, stars = [], lines = [], t0 = performance.now(), on = true, raf;
    function rnd(a) { var s = a; return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }
    function size() {
      D = Math.min(window.devicePixelRatio || 1, 2); W = c.clientWidth; H = c.clientHeight;
      c.width = W * D; c.height = H * D; x.setTransform(D, 0, 0, D, 0, 0);
      var r = rnd(7), n = Math.round(W * H / 5200); stars = [];
      for (var i = 0; i < n; i++) stars.push({ x: r() * W, y: r() * H, s: r() * 1.1 + .25, p: r() * 6.3, k: r() * .6 + .2 });
      lines = []; var g = rnd(11);
      for (var k = 0; k < 3; k++) { var cx = W * (.15 + .7 * g()), cy = H * (.2 + .6 * g()), pts = [];
        for (var j = 0; j < 5; j++) pts.push({ x: cx + (g() - .5) * Math.min(W, 420), y: cy + (g() - .5) * Math.min(H, 260) });
        lines.push(pts); }
    }
    function draw(now) {
      var t = (now - t0) / 1000; x.clearRect(0, 0, W, H);
      var a = rm ? 1 : Math.min(1, t / 2.4);
      x.lineWidth = .6; x.strokeStyle = 'rgba(226,232,245,' + (.16 * a) + ')';
      lines.forEach(function (p) { x.beginPath(); x.moveTo(p[0].x, p[0].y);
        for (var i = 1; i < p.length; i++) x.lineTo(p[i].x, p[i].y); x.stroke();
        p.forEach(function (q) { x.beginPath(); x.arc(q.x, q.y, 1.6, 0, 7); x.fillStyle = 'rgba(240,243,250,' + (.85 * a) + ')'; x.fill(); }); });
      stars.forEach(function (s) { var o = rm ? s.k : s.k * (.55 + .45 * Math.sin(t * .9 + s.p));
        x.beginPath(); x.arc(s.x, s.y, s.s, 0, 7); x.fillStyle = 'rgba(236,240,250,' + o + ')'; x.fill(); });
      if (!rm && on) raf = requestAnimationFrame(draw);
    }
    size(); draw(performance.now());
    window.addEventListener('resize', function () { size(); if (rm) draw(performance.now()); });
    if ('IntersectionObserver' in window && !rm) new IntersectionObserver(function (e) {
      on = e[0].isIntersecting; cancelAnimationFrame(raf); if (on) raf = requestAnimationFrame(draw);
    }).observe(c);
  }
  function go() { document.querySelectorAll('canvas[data-snr-sky]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
